import { render, staticRenderFns } from "./StatisticsDialog.vue?vue&type=template&id=707a79ce&scoped=true"
import script from "./StatisticsDialog.vue?vue&type=script&lang=js"
export * from "./StatisticsDialog.vue?vue&type=script&lang=js"
import style0 from "./StatisticsDialog.vue?vue&type=style&index=0&id=707a79ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707a79ce",
  null
  
)

export default component.exports